import React from 'react'
import './PropertyRentCompT3.scss'
import PropTypes from 'prop-types'
import {
  PropertyImage,
  UnitMix,
  PropertyInfo,
  DonutChartT2,
  Notes
} from '@components/custom'
import { ReactComponent as SummaryLogo } from '@src/assets/summary_right_logo.svg'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import { RENT_COMPARABLES, RENT_COMPS_PAGE_TITLE } from '@engine/dependencies/constants'

export class PropertyRentCompT3 extends React.Component {

  editPropertyNotes = n => {
    const { propertyData } = this.props.propertyInfoData
    this.props.editFeature({ ...propertyData, isNotesModified: true, notes: n })
  }

  editPropertySourceNotes = n => {
    const { propertyData } = this.props.propertyInfoData
    this.props.editFeature({ ...propertyData, sourceNote: n })
  }

  render() {
    const {
      propertyType,
      templateName,
      templateDataLimits: { unitMixCount, notesCount, sourceNotesCount },
      toggleSettings,
      themeColors,
      donutChartThemeColors,
      propertyNameList,
      headerForPagesInT3
    } = this.props
    const {
      propertyData,
      comparableData,
      chartData,
      signedUrl,
      hideUnitMixTotal,
      unitMixDisclaimerData
    } = this.props.propertyInfoData
    const { hasBranding, hasNotes, hasSourceNotes, hasPageTitle, hasDonut } = toggleSettings
    // const comparableDataT3 = [...comparableData]

    // if (comparableDataT3.length > unitMixCount) {
    //   const comparableDataTotal = comparableDataT3.pop()
    //   comparableDataT3.splice(unitMixCount)
    //   comparableDataT3.push(comparableDataTotal)
    // }

    const imageStyles = {
      width: '320px',
      height: '175px'
    }

    return (
      <div
        data-testid={`property-rent-comps-T3-${propertyType}`}
        className={`${(hasPageTitle || hasBranding) ? 'property-rent-comps-view-T3' : 'no-margin-property-rent-comps-view-T3'} ${headerForPagesInT3.includes(propertyType) ? 'prop-seperator' : 'is-page-bottom'}`}
        id={`#property_${propertyType}`}
      >
        {(hasPageTitle || hasBranding) && (
          <>
            {headerForPagesInT3.includes(propertyType) && (hasBranding || hasPageTitle) && (
              <div>
                <div className="summary-header">
                  <span>
                    <p style={{ color: themeColors.globalSubColor }}>{hasPageTitle ? RENT_COMPS_PAGE_TITLE : ''}</p>
                  </span>
                  {hasBranding && (
                    <SummaryLogo data-testid="logo-long" className="summary_logo" />
                  )}
                </div>
              </div>
            )}
          </>
        )}

        <div className="property-container">
          <div className="property-container-left">
            <PropertyImage
              propertyType={propertyType}
              imageUrl={signedUrl || ''}
              style={imageStyles}
              templateName={templateName}
            />
            <PropertyInfo
              propertyInfo={propertyData}
              propertyType={propertyType}
              templateName={templateName}
              propertyNameList={propertyNameList}
            />
            <div className="source_notes">
              {templateName.includes(RENT_COMPARABLES) && hasSourceNotes && (
                <Notes
                  notesContent={propertyData.sourceNote}
                  notesLimit={sourceNotesCount}
                  updateNotes={this.editPropertySourceNotes}
                  propertyLabel={'sourcenotes'}
                />
              )}
            </div>
          </div>
          <div className="property-container-center">
            <UnitMix comparableData={comparableData} unitMixCount={unitMixCount} propertyType={propertyType} hideUnitMixTotal={hideUnitMixTotal} unitMixDisclaimerData={unitMixDisclaimerData} />
          </div>
          <div className="property-container-right">
            {hasDonut && <DonutChartT2
              chartData={chartData}
              donutChartThemeColors={donutChartThemeColors}
              noHeader={true}
              propertyType={propertyType}
              themeColors={themeColors}
            />}
            <div className={hasDonut ? 'empty_notes' : ''}>
              {templateName.includes(RENT_COMPARABLES) && hasNotes && (
                <Notes
                  notesContent={propertyData.notes}
                  notesLimit={notesCount}
                  updateNotes={this.editPropertyNotes}
                  propertyLabel={'notes'}
                  height={hasDonut ? '' : '350px'}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

PropertyRentCompT3.propTypes = {
  donutChartThemeColors: PropTypes.object,
  editFeature: PropTypes.func,
  templateName: PropTypes.string,
  toggleSettings: PropTypes.shape({
    templateType: PropTypes.string,
    hasBranding: PropTypes.bool,
    hasSourceNotes: PropTypes.bool,
    hasNotes: PropTypes.bool,
    hasPageTitle: PropTypes.bool
  }),
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  propertyInfoData: PropTypes.shape({
    propertyData: PropTypes.object,
    comparableData: PropTypes.arrayOf(
      PropTypes.object
    ),
    chartData: PropTypes.shape({
      '1 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 2 Bath': PropTypes.number,
      '3 Bedroom / 3 Bath': PropTypes.number
    }),
    signedUrl: PropTypes.string,
    hideUnitMixTotal: PropTypes.bool,
    unitMixDisclaimerData: PropTypes.object
  }),
  templateDataLimits: PropTypes.shape({
    unitMixCount: PropTypes.number,
    notesCount: PropTypes.number
  }),
  themeColors: PropTypes.object,
  propertyNameList: PropTypes.array,
  headerForPagesInT3: PropTypes.array
}

const mapStateToProps = state => ({
  templateDataLimits: Comps.selectors.comps.templateDataLimits(state),
  themeColors: Comps.selectors.comps.themeColors(state)
})

export default connect(mapStateToProps)(PropertyRentCompT3)
